import React from 'react';
import styled, { css } from 'styled-components';
import { OzoneDrawer, OzoneDrawerProps } from 'components/atoms/drawer';
import {
  Caption01,
  ProductiveHeading05,
  SingleLineEllipsis,
} from 'components/styles';

export const PrimaryTitle = styled.div`
  ${ProductiveHeading05};
  ${SingleLineEllipsis};
  color: var(--black-100);
  width: 80%;
`;
export const SecondaryTitle = styled.div`
  ${Caption01};
  color: var(--black-100);
  opacity: 0.4;
`;
const DrawerComp = (props) => <OzoneDrawer {...props} width={880} />;

export const DashBoardDrawer = styled(DrawerComp)<
  OzoneDrawerProps & { gray: boolean; large: boolean }
>`
  &.dashboard-widget-drawer {
    transition: width 0.2s, transform 0.15s;
  }
  &.dashboard-widget-drawer {
    width: ${({ large }) => (large ? '1080px !important' : '')};
  }
  ${({ gray }) =>
    gray
      ? css`
          .ant-drawer-body {
            background-color: var(--coolest-gray-20);
          }
        `
      : ''};
  ${({ large }) => {
    return large
      ? css`
          .drawer__body {
            height: 100%;
            padding: 68px 0 0;
            top: -68px;
          }
          .ant-drawer-body {
            overflow-y: hidden;
          }
        `
      : '';
  }}
  .drawer__body {
    position: relative;
    top: 0px;
  }
`;
